module.exports = __webpack_public_path__ + "media/flags/lt-a28c2640.svg";